import React from 'react';
import { loadCurrentState } from '../storage';
import { useCheckboxWithTimestamp } from '../hooks/useCheckboxWithTimestamp';

export const useVentilationEquipmentStatus = () => {
  const saved = loadCurrentState();
  const equipment = saved?.ventilationEquipment || {};
  const states = [
    equipment.pulseSaturationSensor,
    equipment.mask,
    equipment.oxygenConcentration,
    equipment.suctionEquipment
  ];
  const checked = states.filter(Boolean).length;
  return { checked, total: 4 };
};

const VentilationEquipment: React.FC = () => {
  const saved = loadCurrentState();

  const [pulseSaturationSensor, setPulseSaturationSensor] = useCheckboxWithTimestamp(
    'ventilationEquipment',
    'pulseSaturationSensor',
    saved?.ventilationEquipment?.pulseSaturationSensor || false
  );
  const [mask, setMask] = useCheckboxWithTimestamp(
    'ventilationEquipment',
    'mask',
    saved?.ventilationEquipment?.mask || false
  );
  const [oxygenConcentration, setOxygenConcentration] = useCheckboxWithTimestamp(
    'ventilationEquipment',
    'oxygenConcentration',
    saved?.ventilationEquipment?.oxygenConcentration || false
  );
  const [suctionEquipment, setSuctionEquipment] = useCheckboxWithTimestamp(
    'ventilationEquipment',
    'suctionEquipment',
    saved?.ventilationEquipment?.suctionEquipment || false
  );

  return (
    <div className="section-content-wrapper" style={{ padding: '20px', direction: 'rtl' }}>
      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={pulseSaturationSensor}
            onChange={(e) => setPulseSaturationSensor(e.target.checked)}
          />
          <span>סנסור דופק סטורציה ומדבקות מוניטור</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={mask}
            onChange={(e) => setMask(e.target.checked)}
          />
          <span>מסיכה 0, 00</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={oxygenConcentration}
            onChange={(e) => setOxygenConcentration(e.target.checked)}
          />
          <span>כיוון ריכוז חמצן ולחצי הנשמה במפוח יד/neopuff</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={suctionEquipment}
            onChange={(e) => setSuctionEquipment(e.target.checked)}
          />
          <span>ציוד לשאיבת הפרשות - סקשן</span>
        </label>
      </div>
    </div>
  );
};

export default VentilationEquipment;
